/**
 * @module app.shared
 */


export class NoAccess {

    constructor() { }

}
